{
  "actions": "Działania",
  "hideButtonLabel": "Wyświetl mniej",
  "noTags": "Brak",
  "showAllButtonLabel": "Pokaż wszystko ({tagCount, number})"
}
